'use client';

import type { ManualHeadingsResponse } from 'src/types/manual/manual-domain';

import { useQuery } from '@tanstack/react-query';

import { guideKeys } from 'src/query-keys/guide';

import { fetchManualHeadings } from './fetch/guide-manual-fetch';

const NO_HEADINGS: ManualHeadingsResponse['items'] = [];

/**
 * 매뉴얼마다 본문 제목 — 가이드 검색의 찾을 거리.
 * ⚠️ 못 받아도 검색은 선다 — 매뉴얼 제목·부제만으로 찾는다(빈 목록).
 * @param enabled 검색칸을 처음 건드린 뒤에만 묻는다
 */
export function useGuideHeadingsLoad(enabled: boolean) {
  const query = useQuery({
    queryKey: guideKeys.headings(),
    queryFn: ({ signal }) => fetchManualHeadings(signal),
    enabled,
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
    refetchOnWindowFocus: false,
    retry: false,
  });
  return query.data?.items ?? NO_HEADINGS;
}
